import React from 'react';
import PropTypes from 'prop-types';
// import { tracker } from '../util/tracker';

// const propNames = ['track'];

class NewTabLink extends React.Component {
  render() {
    return (
      <a target="_blank" rel="noopener" {...this.props}>
        {this.props.children}
      </a>
    );
  }
}

NewTabLink.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
  track: PropTypes.string
};

export { NewTabLink };
